module.exports = __webpack_public_path__ + "static/digirytePods-9631b61884b5a87d221bbdec80d33a1a.png";